import { makeStyles } from '@material-ui/core';
import { baseColors } from '@ncr-retail/mui-theme';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

const baseColor = baseColors();

export const styles = makeStyles(theme => ({
  component: {
    height: '100%',
  },
  fullWidth: {
    width: '100%',
  },
  itemContainer: {
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    minHeight: '6.07vh',
    border: `1px solid ${themeColor.secondaryLight}`,
    cursor: 'pointer',
  },
  productNameContainer: {
    justifyContent: 'flex-start',
    padding: '0.8vh',
    paddingLeft: '0.975vw',
    paddingRight: '0.975vw',
  },
  priceContainer: {
    justifyContent: 'flex-start',
  },
  productInformation: {
    fontSize: rem(0.875),
    '@media(width: 1366px) and (height:768px)': {
      fontSize: rem(1.1232),
    },
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: baseColor.bigstone,
  },
  priceInformation: {
    fontSize: rem(0.875),
    '@media(width: 1366px) and (height:768px)': {
      fontSize: rem(1.1232),
    },
    textAlign: 'start',
    paddingLeft: '3.525vw',
    width: '100%',
    color: baseColor.bigstone,
  },
  selected: {
    border: `2px solid ${theme.palette.secondary.main}`,
    '& .search-result-image': {
      width: '4.02vw',
      height: '7.16vh',
      marginTop: '0.13vh',
    },
  },
}));
